module.exports = __webpack_public_path__ + "img/addgroupicon.bc6c1c93.svg";